import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { UbUpdateFormComponent } from "./ub-update-form/ub-update-form.component";
import { TranslateModule } from "@ngx-translate/core";
import { BetPlacementService } from "../../../../../../../shared/src/lib/services/bet-placement.service";
import { filter, Subject, switchMap } from "rxjs";
import { BetService } from "../../../../../../../shared/src/lib/services/bet.service";
import { Bet, Market } from "../../../../../../../shared/src/lib/types/bet.type";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-unmatched-bets",
  imports: [UbUpdateFormComponent, TranslateModule],
  templateUrl: "./unmatched-bets.component.html",
  styleUrl: "./unmatched-bets.component.scss",
})
export class UnmatchedBetsComponent implements OnInit, OnChanges, OnDestroy {
  readonly destroy$ = new Subject<void>();
  @Input() data: any[] = [];
  @Input() context: string = "";
  betMarkets: Record<string, Market> = {};

  constructor(
    private readonly betPlacementService: BetPlacementService,
    private readonly betService: BetService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["data"]) {
      this._init();
    }
  }

  ngOnInit() {
    this._init();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  _init() {
    this.betPlacementService.openBetsSubject
      .pipe(
        filter((unmatchedBets) => unmatchedBets.length > 0),
        switchMap((unmatchedBets) => this.betService.getDetailsForMultipleNonPendingBfMarkets(unmatchedBets.map((bet: Bet) => bet.marketId))),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (unmatchedBetsMarkets) => {
          if (Array.isArray(unmatchedBetsMarkets)) {
            const tempUnmatchedBetsMarkets: Record<string, Market> = {};
            unmatchedBetsMarkets.forEach((market) => {
              tempUnmatchedBetsMarkets[market.marketId] = market;
            });
            this.betMarkets = tempUnmatchedBetsMarkets;
          } else {
            this.betMarkets = {
              [unmatchedBetsMarkets.marketId]: unmatchedBetsMarkets,
            };
          }
        },
      });
  }
}
